<div class="avatar" [ngClass]="[size, bordered ? 'bordered' : '']" [ngStyle]="{'background-color': color}">
  <div class="text" >{{ initials }}</div>
</div>
